import { removeCustomAnswer } from 'api/operations/productServiceV2';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

interface RemoveAttributeModalStoreProps {
  templateId: string;
  updateProductTemplate: (templateId: string) => Promise<void> | void;
}

export class RemoveAttributeModalStore extends ModalDelegate {
  private _modalLoading = false;
  private _attributeId: string = '';
  private _templateId: string = '';

  private _updateProductTemplate: (templateId: string) => Promise<void> | void;

  public get modalLoading(): boolean {
    return this._modalLoading;
  }

  public get attributeId(): string {
    return this._attributeId;
  }

  public get isRemoveAttributeModalOpen(): boolean {
    return this.isVisible;
  }

  private setModalLoading(value: boolean): void {
    this._modalLoading = value;
  }

  public openRemoveAttributeModal(attributeId: string): void {
    this._attributeId = attributeId;
    this.open();
  }

  public closeRemoveAttributeModal(): void {
    this.close();
    this._attributeId = '';
  }

  public async removeCustomAttribute(): Promise<void> {
    if (!this._templateId || !this._attributeId) return;

    this.setModalLoading(true);
    await removeCustomAnswer(this._templateId, this._attributeId);
    void runInAction(async () => {
      await this._updateProductTemplate(this._templateId);
      this.setModalLoading(false);
      this.closeRemoveAttributeModal();
    });
  }

  constructor({ templateId, updateProductTemplate }: RemoveAttributeModalStoreProps) {
    super();
    this._updateProductTemplate = updateProductTemplate;
    this._templateId = templateId;

    makeObservable<RemoveAttributeModalStore, '_modalLoading' | '_attributeId' | '_templateId' | 'setModalLoading'>(
      this,
      {
        _modalLoading: observable,
        _attributeId: observable,
        _templateId: observable,

        modalLoading: computed,
        attributeId: computed,

        openRemoveAttributeModal: action.bound,
        closeRemoveAttributeModal: action.bound,
        removeCustomAttribute: action.bound,
        setModalLoading: action.bound,
      },
    );
  }
}
